module.exports = [
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2000",
    "Rate": 869.93
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2002-2004",
    "Rate": 846.77
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2005-2007",
    "Rate": 797.2
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2010",
    "Rate": 706.43
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2011-2013",
    "Rate": 652.73
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2014-2016",
    "Rate": 660.57
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2018",
    "Rate": 604.9
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2000",
    "Rate": 445.03
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2002-2004",
    "Rate": 480.37
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2005-2007",
    "Rate": 482.6
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2010",
    "Rate": 473.43
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2011-2013",
    "Rate": 470.43
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2014-2016",
    "Rate": 466.63
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2018",
    "Rate": 457.75
  }
]
